/**
 * create by huangjianlin  2020-04-02 17:48
 */
export const YESTERDAY = '1'
export const TODAY = '2'
export const LAST_MONTH = '3'
export const THIS_MONTH = '4'
export const LAST_YEAR = '5'
export const THIS_YEAR = '6'
export const BEFORE_DAY = '7' // 前一天
export const NEXT_DAY = '8' // 下一日
export const CLUB_ID = 'club_id'
export const NO_DISCOUNT = 1 //无折购



// WEBPACK FOOTER //
// ./src/const.js